var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kustomer-header"},[_c('div',{staticClass:"kustomer-logo"},[_vm._t("logo")],2),_vm._v(" "),_vm._t("title")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }